import { ExaminationSessionDto } from './examination-session.model';
import { ExaminationSession } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { ExerciseResult } from '@lyceo/shared/util-models';

export function mapExaminationSession(
  examinationSessionDto: ExaminationSessionDto,
): ExaminationSession {
  return {
    id: examinationSessionDto.id,
    questionsCorrect: examinationSessionDto.questionsCorrect,
    totalQuestions: examinationSessionDto.totalQuestions,
    finishedAt: examinationSessionDto.finishedAt,
    grade: examinationSessionDto.grade,
    questionnaireId: examinationSessionDto.questionnaireId,
  };
}

export function mapExaminationSessionToExerciseResult(
  examinationSession: ExaminationSession,
): ExerciseResult<ExaminationSession> {
  return {
    id: examinationSession.id,
    questionsCorrect: examinationSession.questionsCorrect,
    totalQuestions: examinationSession.totalQuestions,
    finishedAt: examinationSession.finishedAt,
    grade: examinationSession.grade,
    meta: examinationSession,
  };
}
